import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {FETCH_VOICES} from '../constants/voice';

function data(state = [], action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_VOICES):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_VOICES]),
  error: getErrorReducer([FETCH_VOICES]),
  data
});
